module.exports = __webpack_public_path__ + "img/2-2.5377a058.svg";